module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d6gF4"))).then(() => module.bundle.root('hEqeo'));